import React from 'react';
import { string } from 'prop-types';
import classnames from 'classnames';
import Link from 'components/Link';

import styles from './styles';

function Tip(props) {
  const { title, html, ctaUrl, ctaText, campaign } = props;
  const className = classnames('Tip', `Tip--${campaign}`);
  return (
    <>
      <div className={className}>
        <div className="Tip__header">
          <div className="Tip__header--left" />
          <div className="Tip__header--middle">
            <span>{title}</span>
          </div>
          <div className="Tip__header--right" />
        </div>
        <div
          className="Tip__content"
          dangerouslySetInnerHTML={{ __html: html }}
        />
        <div className="Tip__footer" />
        {ctaUrl && ctaText && (
          <div className="Tip__cta">
            <Link href={ctaUrl}>
              <a>{`${ctaText} >`}</a>
            </Link>
          </div>
        )}
      </div>
      <style jsx>{styles}</style>
    </>
  );
}

Tip.propTypes = {
  title: string.isRequired,
  html: string.isRequired,
  ctaUrl: string,
  ctaText: string,
  campaign: string
};

Tip.defaultProps = {
  ctaUrl: undefined,
  ctaText: undefined,
  campaign: 'default'
};

export default Tip;
